import { useState } from 'react'
import Modal from 'shared/Modal'
import ModalHeader from 'shared/Modal/ModalHeader'
import Button from 'shared/Buttons/Button/Button'
import { ITeam } from 'screens/Teams/teams.types'
import { ReactComponent as MemberIcon } from 'assets/icons/user-solid.svg'
import css from './changeOwnerModal.module.css'

interface IProps {
  team: ITeam
  onSelect: (user: { id: number }) => void
  onClose: () => void
}

const ChangeOwnerModal = (props: IProps) => {
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null)

  const candidates = (props.team.members ?? []).filter((m) => m.userId !== props.team.ownerId)

  const handleApply = () => {
    if (selectedUserId != null) {
      props.onSelect({ id: selectedUserId })
    }
  }

  return (
    <Modal onClose={props.onClose} size='xs' shouldAnimate={false}>
      <ModalHeader onClose={props.onClose}>Передать права лидера команды</ModalHeader>
      <div className={`modal-content flex-lines ${css.content}`}>
        <p className={`text--body-m ${css.description}`}>
          Выберите участника команды, которому передать права лидера. После нажатия «Применить» вы выйдете из команды.
        </p>
        <div className={`flex-lines ${css.list}`}>
          {candidates.length === 0 ? (
            <p className='text--body-m text--secondary'>В команде нет других участников для передачи прав.</p>
          ) : (
            candidates.map((member) => {
              const isSelected = selectedUserId === member.userId
              return (
                <button
                  key={member.userId}
                  type='button'
                  className={css.memberCard}
                  onClick={() => setSelectedUserId(member.userId)}
                >
                  <MemberIcon className={css.memberIcon} />
                  <div className={css.memberInfo}>
                    <div className='text--caption-l text-600'>{member.user?.info?.name ?? 'Участник'}</div>
                    {member.user?.info?.universityGroup && (
                      <div className='text--caption-m text--secondary'>{member.user.info.universityGroup}</div>
                    )}
                  </div>
                  {isSelected && (
                    <span className={css.checkmark} aria-hidden>
                      <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M16.667 5L7.5 14.167 3.333 10'
                          stroke='currentColor'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </span>
                  )}
                </button>
              )
            })
          )}
        </div>
        <div className={`form-footer ${css.footer}`}>
          <div className={`inline-flex-gap ${css.footerActions}`}>
            <Button theme='grey-outline' className={css.button} onClick={props.onClose}>
              Отмена
            </Button>
            <Button theme='primary' className={css.button} onClick={handleApply} disabled={selectedUserId == null}>
              Применить
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ChangeOwnerModal
